import React from 'react';
import { NextPage } from 'next';
import { LocaleProvider } from '@/contexts/locale-context';

export const withLocale = (WrappedPage: NextPage<any>) => {
	return (props) => {
		if (!props.node || !props.node.language) {
			return <WrappedPage {...props} />;
		}
		return (
			<LocaleProvider
				lang={props.node?.language.code.toLowerCase()}
				defaultLang={props.defaultLocale}
				langs={props.locales}
				strings={props.translationStrings}
			>
				<WrappedPage {...props} />
			</LocaleProvider>
		);
	};
};
